/* eslint-disable no-restricted-syntax */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable no-restricted-globals */
export const debounce = (fn, wait = 300) => {
  let timerId = null;
  const debounced = (...args) => {
    clearTimeout(timerId);
    timerId = setTimeout(() => {
      fn(...args);
      timerId = null;
    }, wait);
  };
  return debounced;
};

export const sleep = (wait) => new Promise((resolve) => {
  setTimeout(resolve, wait);
});

// https://developer.mozilla.org/en-US/docs/Web/API/Window/open
export const popupCenter = ({
  url, title, w, h,
}) => {
  // Fixes dual-screen position                             Most browsers      Firefox
  const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
  const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

  const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
  const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

  const systemZoom = width / window.screen.availWidth;
  const left = (width - w) / 2 / systemZoom + dualScreenLeft;
  const top = (height - h) / 2 / systemZoom + dualScreenTop;
  const newWindow = window.open(url, title, `
    scrollbars=yes,
    width=${w / systemZoom}, 
    height=${h / systemZoom}, 
    top=${top}, 
    left=${left}`);

  if (newWindow.focus) newWindow.focus();
};

export const readClipboard = async () => new Promise((resolve, reject) => {
  try {
    navigator.clipboard
      .readText()
      .then(resolve);
  } catch (error) {
    reject(error);
  }
});

/**
 *将数字转换成分隔符形式   1122334 => 1,122,334
 * @param {number | string} val  需要转换的数字
 * @returns 返回转换后的数字
 */
// export const toThousands = (val) => val.toString().replace(/(?=\B(\d{3})+$)/g, ',');
export const toThousands = (val) => val && val.toString().replace(/\d+/, (s) => s.replace(/(\d)(?=(\d{3})+$)/g, '$1,'));

export * from './time';
export * from './price';
